import MarkText from "../components/MarkText.ts";
import Mark from "../marks/Mark.ts";
import MarkData from "../types/MarkData.ts";
import MarkCodes from "../marks/MarkCodes.ts";
import {gsap} from "gsap";
import ARMark from "../marks/ARMark.ts";
import BlendMark from "../marks/BlendMark.ts";
import ConsonantYMark from "../marks/ConsonantYMark.ts";
import ERSoundOfEarMark from "../marks/ERSoundOfEarMark.ts";
import GuardianMark from "../marks/GuardianMark.ts";
import LongMark from "../marks/LongMark.ts";
import ERMark from "../marks/ERMark.ts";
import SoundOfLongOMark from "../marks/SoundOfLongOMark.ts";
import SoundOfFMark from "../marks/SoundOfFMark.ts";
import RainbowJSMark from "../marks/RainbowJSMark.ts";
import SoundOfZMark from "../marks/SoundOfZMark.ts";
import SchwaMark from "../marks/SchwaMark.ts";
import ShortMark from "../marks/ShortMark.ts";
import SilentVowelMark from "../marks/SilentVowelMark.ts";
import SlideArrowMark from "../marks/SlideArrowMark.ts";
import SoundALongMark from "../marks/SoundALongMark.ts";
import SoundYLongEMark from "../marks/SoundYLongEMark.ts";
import SoundYLongMark from "../marks/SoundYLongMark.ts";
import SoundYShortMark from "../marks/SoundYShortMark.ts";
import SplitText from "../components/SplitText.ts";
import SyllableSplitMark from "../marks/SyllableSplitMark.ts";
import UnderlineMark from "../marks/UnderlineMark.ts";
import VoicedVoicelessMark from "../marks/VoicedVoicelessMark.ts";
import VowelMark from "../marks/VowelMark.ts";
import VowelExceptionMark from "../marks/VowelExceptionMark.ts";
import VowelExceptionShortSoundMark from "../marks/VowelExceptionShortSoundMark.ts";
import ShortOMark from "../marks/ShortOMark.ts";
import PlaceholderMark from "../marks/PlaceholderMark.ts";
import DecodingCommand from "../types/DecodeCommand.ts";
import {Application, Point} from "pixi.js";
import Placement from "../types/Placement.ts";
import RhColors from "../models/RhColors.ts";
import DecodingModel from "@/models/DecodingModel.ts";

export default class MarkUtil
{
    private static _instance: MarkUtil = new MarkUtil();

    private _decodingCommands:DecodingCommand[];
    
    private getSymbolPlacement(symbol:string):string
    {
        if(symbol == MarkCodes.SLIDE_ARROW
            || symbol == MarkCodes.VOWEL
            || symbol == MarkCodes.BLEND_2_LETTER
            || symbol == MarkCodes.BLEND_3_LETTER
            || symbol == MarkCodes.BLEND_4_LETTER
            || symbol == MarkCodes.VOICED_TH
            || symbol == MarkCodes.VOICELESS_TH
            || symbol == MarkCodes.UNDERLINE
            || symbol == MarkCodes.VOWEL_2_LETTER
            || symbol == MarkCodes.VOWEL_EXCEPTION)
        {
            return Placement.BTM;
        }
        else if(symbol == MarkCodes.SYLLABLE_BEGIN || symbol == MarkCodes.SYLLABLE_END)
        {
            return Placement.SYLLABLE;
        }
        return Placement.TOP;
    }

    private isNumber(value:string):boolean
    {
        return !isNaN(Number(value));
    }

    private twoUnderlineCodesFound():boolean
    {
        let found:boolean = false;
        let underlinesFoundCount:number = 0;
        const len = this._decodingCommands.length;
        for(let i=0; i<len; i++)
        {
            if(this._decodingCommands[i].code == MarkCodes.UNDERLINE)
            {
                underlinesFoundCount++;
            }
        }
        if(underlinesFoundCount >= 2)
        {
            found = true;
        }
        return found;
    }


    public convertCodeToCommaCode(code:string):string
    {
        if(code.indexOf(",") != -1)
        {
            return code;
        }
        let commaCode = "";
        let len = code.length;
        let curChar = "";
        let nextChar = "";
        for(let i=0; i<len; i++)
        {
            curChar = code.charAt(i);
            if(i+1 < len)
            {
                nextChar = code.charAt(i+1);
                if(isNaN(Number(curChar)) && !isNaN(Number(nextChar)))
                {
                    commaCode += curChar + ",";
                }
                else
                {
                    commaCode += curChar;
                }
            }
            else
            {
                commaCode += curChar;
            }
        }
        return commaCode;
    }

    public createAndDisplayAllMarks(targetSplitText:SplitText, decodingCommands?:DecodingCommand[], marksArray?:Mark[], markColor=RhColors.MARK_PRIMARY):void
    {
        //debugger;
        if(decodingCommands)
        {
            this._decodingCommands = decodingCommands;
        }
        let curCommandIndex = 0;
        const len = this._decodingCommands.length;
        let curCommand:DecodingCommand;
        let curMark:Mark;
        let targetTextField:MarkText;
        for(let i:number=0; i<len; i++)
        {
            curCommandIndex = i;
            curCommand = this._decodingCommands[i];
            if(curCommand.position == 0 || curCommand.position == targetSplitText.numChars+1)
            {
                continue;
            }
            if(curCommand.code != MarkCodes.SYLLABLE_END)
            {
                targetTextField = targetSplitText.textFields[curCommand.position-1];
                const curMark:Mark = this.createAndDisplayMark(curCommand.code, targetSplitText, targetTextField, 0, 0.01, null, markColor);
                if(marksArray)
                {
                    marksArray.push(curMark);
                }
            }
        }
    }

    public createAndDisplayMark(code:string, targetSplitText:SplitText, targetTextField:MarkText=null, commandIndex=0, fadeInDuration=1, onComplete=null, markColor:string=RhColors.MARK_PRIMARY, markAdjustPoint:Point=null):Mark
    {
        DecodingModel.getInstance().curDecodingIndex = this._decodingCommands[commandIndex].position;
        const mark:Mark = this.createMark(code, targetSplitText, targetTextField, fadeInDuration, onComplete, markColor, this._decodingCommands[commandIndex].position, markAdjustPoint);
        mark.alpha = 0;
        if(mark.parentTarget != undefined)
        {
            mark.parentTarget.addMarkData(new MarkData(this._decodingCommands[commandIndex].code, this._decodingCommands[commandIndex].position));
            mark.parentTarget.addChild(mark);
        }
        else
        {
            mark.markX = 0;
            mark.markY = 0;
            const app = new Application();
            app.stage.label = "Dynamic Mark App";
            (async () => {
                await app.init();
                app.stage.addChild(mark);
            })()
        }
        mark.create();
        if(code == MarkCodes.PH_MAKES_SOUND_OF_F)
        {
            //debugger;
        }
        else if (code == MarkCodes.SLIDE_ARROW)
        {
            
        }
        else
        {
            mark.pivot.set(mark.markWidth/2, mark.markHeight/2);
        }
        //debugger;
        mark.x = mark.markX;
        mark.y = mark.markY;
        return mark;
    }

    public createMark(code:string, targetSplitText:SplitText, targetTextField:MarkText=null, fadeInDuration=1, onComplete=null, markColor:string=RhColors.MARK_PRIMARY, position:number = 0, markAdjustPoint?:Point):Mark
    {
        let mark:Mark;
        switch (code)
        {
            case MarkCodes.AR_SOUND_OF_OR:
                mark = new ARMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.BLEND_2_LETTER:
                mark = new BlendMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                }
                break;
            case MarkCodes.BLEND_3_LETTER:
                mark = new BlendMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getThreeLetterWidth(targetSplitText, targetTextField);
                }
                break;
            case MarkCodes.BLEND_4_LETTER:
                mark = new BlendMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getFourLetterWidth(targetSplitText, targetTextField);
                }
                break;
            case MarkCodes.CONSONANT_Y:
                mark = new ConsonantYMark(targetTextField, markColor);
                break;
            /*case MarkCodes.EA_SOUND_OF_SHORT_E_EA:
                mark = new SoundOfShortEMark(targetTextField);
                break;*/
            case MarkCodes.ER_SOUND_OF_EAR:
                mark = new ERSoundOfEarMark(targetTextField, markColor);
                break;
            case MarkCodes.GUARDIAN:
                mark = new GuardianMark(targetTextField, markColor);
                break;
            case MarkCodes.GUARDIAN_2_LETTER:
                mark = new GuardianMark(targetTextField, markColor, 2, this.getTwoLetters(targetSplitText, targetTextField));
                if(targetTextField)
                {
                    mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.GUARDIAN_3_LETTER:
                mark = new GuardianMark(targetTextField, markColor, 3, this.getThreeLetters(targetSplitText, targetTextField));
                if(targetTextField)
                {
                    mark.markX = this.getThreeLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.LONG:
                mark = new LongMark(targetTextField, markColor);
                break;
            case MarkCodes.OR_SOUND_OF_ER:
                mark = new ERMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.OW_SOUND_OF_LONG_O:
                mark = new SoundOfLongOMark(targetTextField, markColor);
                break;
            case MarkCodes.PH_MAKES_SOUND_OF_F:
                mark = new SoundOfFMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.RAINBOW_J:
                mark = new RainbowJSMark(targetTextField, "j", markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            case MarkCodes.RAINBOW_J_GUARDIAN:
                mark = new GuardianMark(targetTextField, markColor, 1, "j", true);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            case MarkCodes.RAINBOW_S_GUARDIAN:
                mark = new GuardianMark(targetTextField, markColor, 1, "s", true);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            case MarkCodes.RAINBOW_S:
                mark = new RainbowJSMark(targetTextField, "s", markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            case MarkCodes.S_SOUND_OF_Z:
                mark = new SoundOfZMark(targetTextField, markColor);
                break;
            case MarkCodes.SCHWA:
                mark = new SchwaMark(targetTextField, false, markColor);
                break;
            case MarkCodes.SCHWA_LE_ENDINGS:
                mark = new SchwaMark(targetTextField, true, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                    mark.markY = 30;
                }
                break;
            case MarkCodes.SHORT:
                mark = new ShortMark(targetTextField, markColor);
                break;
            case MarkCodes.SILENT_VOWEL:
                mark = new SilentVowelMark(targetTextField, markColor);
                break;
            case MarkCodes.SLIDE_ARROW:
                mark = new SlideArrowMark(targetSplitText, markColor, position);
                //mark.markY = 78;
                break;
            /*case MarkCodes.SOUND_OF_K:
                mark = new SoundOfKMark(targetTextField);
                break;*/
            case MarkCodes.SOUND_OF_LONG_A:
                mark = new SoundALongMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            /*case MarkCodes.SOUND_OF_SH:
                mark = new SoundSHMark(targetTextField);
                break;*/
            case MarkCodes.SOUND_OF_Y_LONG_E:
                mark = new SoundYLongEMark(targetTextField, markColor);
                break;
            case MarkCodes.SOUND_OF_Y_LONG_I:
                mark = new SoundYLongMark(targetTextField, markColor);
                break;
            case MarkCodes.SOUND_OF_Y_SHORT_I:
                mark = new SoundYShortMark(targetTextField, markColor);
                break;
            case MarkCodes.SYLLABLE_BEGIN:
            case MarkCodes.SYLLABLE_END:
            case MarkCodes.SYLLABLE_SPLIT:
                mark = new SyllableSplitMark(targetTextField, markColor);
                break;
            case MarkCodes.UNDERLINE:
                mark = new UnderlineMark(targetTextField, markColor);
                if(targetTextField)
                {
                    mark.markWidth = this.getWidthToLastChar(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                    if (this.twoUnderlineCodesFound()) {

                    }
                }
                break;
            case MarkCodes.VOICED_TH:
                mark = new VoicedVoicelessMark(targetTextField, MarkCodes.VOICED_TH, markColor);
                if(targetTextField) {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                }
                break;
            case MarkCodes.VOICELESS_TH:
                mark = new VoicedVoicelessMark(targetTextField, MarkCodes.VOICELESS_TH, markColor);
                if(targetTextField) {
                    mark.markWidth = this.getTwoLetterWidth(targetSplitText, targetTextField);
                    mark.markX = mark.markWidth/2;
                }
                break;
            case MarkCodes.VOWEL:
                mark = new VowelMark(targetTextField, markColor);
                break;
            case MarkCodes.VOWEL_2_LETTER:
                mark = new VowelMark(targetTextField, markColor);
                mark.markX = this.getTwoLetterWidth(targetSplitText, targetTextField)/2;
                break;
            case MarkCodes.VOWEL_EXCEPTION:
                mark = new VowelExceptionMark(targetTextField, markColor);
                break;
            case MarkCodes.VOWEL_EXCEPTION_SHORT_SOUND:
                mark = new VowelExceptionShortSoundMark(targetTextField, markColor);
                break;
            case MarkCodes.VOWEL_SHORT_O_SOUND:
                mark = new ShortOMark(targetTextField, markColor);
                break;
            default:
                mark = new PlaceholderMark(targetTextField, markColor);
        }
        if(markAdjustPoint)
        {
            mark.markX += markAdjustPoint.x;
            mark.markY += markAdjustPoint.y;
        }
        if(onComplete)
        {
            gsap.to(mark, {duration: fadeInDuration, alpha:1, ease:"power4.out", onComplete:onComplete});
        }
        else
        {
            gsap.to(mark, {duration: fadeInDuration, alpha:1, ease:"power4.out"});
        }
        return mark
    }
    
    public getDecodingCommands():DecodingCommand[]
    {
        return this._decodingCommands;
    }

    public static getInstance(): MarkUtil {
        return this._instance;
    }

    public getFourLetterWidth(targetSplitText:SplitText, targetTextField:MarkText):number
    {
        let width:number = 0;
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                width += targetSplitText.textFields[i].width;
                if(i+1 < len)
                {
                    width += targetSplitText.textFields[i+1].width;
                }
                if(i+2 < len)
                {
                    width += targetSplitText.textFields[i+2].width;
                }
                if(i+3 < len)
                {
                    width += targetSplitText.textFields[i+2].width;
                }
                break;
            }
        }
        return width;
    }

    public static getPlacement(code:string):string
    {
        let placement:string = Placement.BTM;
        switch(code)
        {
            case MarkCodes.AR_SOUND_OF_OR:
                placement = Placement.TOP;
                break;
            case MarkCodes.BLEND_2_LETTER:
            case MarkCodes.BLEND_3_LETTER:
            case MarkCodes.BLEND_4_LETTER:
                placement = Placement.BTM;
                break;
            case MarkCodes.CONSONANT_Y:
                placement = Placement.TOP;
                break;
            case MarkCodes.ER_SOUND_OF_EAR:
                placement = Placement.TOP;
                break;
            case MarkCodes.GUARDIAN:
                placement = Placement.TOP;
                break;
            case MarkCodes.GUARDIAN_2_LETTER:
                placement = Placement.TOP;
                break;
            case MarkCodes.GUARDIAN_3_LETTER:
                placement = Placement.TOP;
                break;
            case MarkCodes.LONG:
                placement = Placement.TOP;
                break;
            case MarkCodes.OR_SOUND_OF_ER:
                placement = Placement.TOP;
                break;
            case MarkCodes.OW_SOUND_OF_LONG_O:
                placement = Placement.TOP;
                break;
            case MarkCodes.PH_MAKES_SOUND_OF_F:
                placement = Placement.TOP;
                break;
            case MarkCodes.RAINBOW_J:
                placement = Placement.TOP;
                break;
            case MarkCodes.RAINBOW_S:
                placement = Placement.TOP;
                break;
            case MarkCodes.S_SOUND_OF_Z:
                placement = Placement.TOP;
                break;
            case MarkCodes.SCHWA:
                placement = Placement.TOP;
                break;
            case MarkCodes.SCHWA_LE_ENDINGS:
                placement = Placement.TOP;
                break;
            case MarkCodes.SHORT:
                placement = Placement.TOP;
                break;
            case MarkCodes.SILENT_VOWEL:
                placement = Placement.TOP;
                break;
            case MarkCodes.SLIDE_ARROW:
                placement = Placement.BTM;
                break;
            case MarkCodes.SOUND_OF_LONG_A:
                placement = Placement.TOP;
                break;
            case MarkCodes.SOUND_OF_Y_LONG_E:
                placement = Placement.TOP;
                break;
            case MarkCodes.SOUND_OF_Y_LONG_I:
                placement = Placement.TOP;
                break;
            case MarkCodes.SOUND_OF_Y_SHORT_I:
                placement = Placement.TOP;
                break;
            case MarkCodes.SYLLABLE_BEGIN:
            case MarkCodes.SYLLABLE_END:
            case MarkCodes.SYLLABLE_SPLIT:
                placement = Placement.TOP;
                break;
            case MarkCodes.UNDERLINE:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOICED_TH:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOICELESS_TH:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOWEL:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOWEL_2_LETTER:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOWEL_EXCEPTION:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOWEL_EXCEPTION_SHORT_SOUND:
                placement = Placement.BTM;
                break;
            case MarkCodes.VOWEL_SHORT_O_SOUND:
                placement = Placement.BTM;
                break;
        }
        return placement;
    }
    
    public static getPositionsMerged(code:string):number
    {
        let mergedPositions:number = 1;
        switch(code)
        {
            case MarkCodes.AR_SOUND_OF_OR:
                mergedPositions = 2;
                break;
            case MarkCodes.BLEND_2_LETTER:
                mergedPositions = 2;
                break;
            case MarkCodes.BLEND_3_LETTER:
                mergedPositions = 3;
                break;
            case MarkCodes.BLEND_4_LETTER:
                mergedPositions = 4;
                break;
            case MarkCodes.CONSONANT_Y:
               mergedPositions = 1;
                break;
            case MarkCodes.ER_SOUND_OF_EAR:
                mergedPositions = 2;
                break;
            case MarkCodes.GUARDIAN:
                mergedPositions = 1;
                break;
            case MarkCodes.GUARDIAN_2_LETTER:
                mergedPositions = 2;
                break;
            case MarkCodes.GUARDIAN_3_LETTER:
                mergedPositions = 3;
                break;
            case MarkCodes.LONG:
                mergedPositions = 1;
                break;
            case MarkCodes.OR_SOUND_OF_ER:
                mergedPositions = 2;
                break;
            case MarkCodes.OW_SOUND_OF_LONG_O:
                mergedPositions = 2;
                break;
            case MarkCodes.PH_MAKES_SOUND_OF_F:
                mergedPositions = 2;
                break;
            case MarkCodes.RAINBOW_J:
                mergedPositions = 2;
                break;
            case MarkCodes.RAINBOW_S:
                mergedPositions = 2;
                break;
            case MarkCodes.S_SOUND_OF_Z:
                mergedPositions = 1;
                break;
            case MarkCodes.SCHWA:
                mergedPositions = 2;
                break;
            case MarkCodes.SCHWA_LE_ENDINGS:
                mergedPositions = 2;
                break;
            case MarkCodes.SHORT:
                mergedPositions = 1;
                break;
            case MarkCodes.SILENT_VOWEL:
                mergedPositions = 1;
                break;
            case MarkCodes.SLIDE_ARROW:
                mergedPositions = -1;
                break;
            case MarkCodes.SOUND_OF_LONG_A:
                mergedPositions = 1;
                break;
            case MarkCodes.SOUND_OF_Y_LONG_E:
                mergedPositions = 1;
                break;
            case MarkCodes.SOUND_OF_Y_LONG_I:
                mergedPositions = 1;
                break;
            case MarkCodes.SOUND_OF_Y_SHORT_I:
                mergedPositions = 1;
                break;
            case MarkCodes.SYLLABLE_BEGIN:
            case MarkCodes.SYLLABLE_END:
            case MarkCodes.SYLLABLE_SPLIT:
                mergedPositions = 0;
                break;
            case MarkCodes.UNDERLINE:
                mergedPositions = -1;
                break;
            case MarkCodes.VOICED_TH:
                mergedPositions = 2;
                break;
            case MarkCodes.VOICELESS_TH:
                mergedPositions = 2;
                break;
            case MarkCodes.VOWEL:
                mergedPositions = 1;
                break;
            case MarkCodes.VOWEL_2_LETTER:
                mergedPositions = 2;
                break;
            case MarkCodes.VOWEL_EXCEPTION:
                mergedPositions = 2;
                break;
            case MarkCodes.VOWEL_EXCEPTION_SHORT_SOUND:
                mergedPositions = 1;
                break;
            case MarkCodes.VOWEL_SHORT_O_SOUND:
                mergedPositions = 1;
                break;
        }
        return mergedPositions;
    }

    public getThreeLetters(targetSplitText:SplitText, targetTextField:MarkText):string
    {
        let letters:string = "";
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                letters += targetSplitText.textFields[i].text;
                if(i+1 < len)
                {
                    letters += targetSplitText.textFields[i+1].text;
                }
                if(i+2 < len)
                {
                    letters += targetSplitText.textFields[i+2].text;
                }
                break;
            }
        }
        return letters;
    }
    
    public getThreeLetterWidth(targetSplitText:SplitText, targetTextField:MarkText, rightToLeft:boolean=false):number
    {
        let width:number = 0;
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                width += targetSplitText.textFields[i].width;
                if(rightToLeft)
                {
                    if(i+1 < len)
                    {
                        width += targetSplitText.textFields[i-1].width;
                    }
                    if(i+2 < len)
                    {
                        width += targetSplitText.textFields[i-2].width;
                    }
                }
                else
                {
                    if(i+1 < len)
                    {
                        width += targetSplitText.textFields[i+1].width;
                    }
                    if(i+2 < len)
                    {
                        width += targetSplitText.textFields[i+2].width;
                    }
                }
                break;
            }
        }
        return width;
    }

    public getTwoLetters(targetSplitText:SplitText, targetTextField:MarkText):string
    {
        let letters:string = "";
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                letters += targetSplitText.textFields[i].text;
                if(i+1 < len)
                {
                    letters += targetSplitText.textFields[i+1].text;
                }
                break;
            }
        }
        return letters;
    }
    
    public getTwoLetterWidth(targetSplitText:SplitText, targetTextField:MarkText, rightToLeft:boolean=false):number
    {
        let width:number = 0;
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                width += targetSplitText.textFields[i].width;
                if(rightToLeft)
                {
                    if(i-1 >= 0)
                    {
                        width += targetSplitText.textFields[i-1].width;
                    }
                }
                else
                {
                    if(i+1 < len)
                    {
                        width += targetSplitText.textFields[i+1].width;
                    }
                }
                break;
            }
        }
        return width;
    }

    public getWidthToLastChar(targetSplitText:SplitText, targetTextField:MarkText):number
    {
        let startIndexFound:boolean = false;
        let width:number = 0;
        const len = targetSplitText.textFields.length;
        for(let i=0; i<len; i++)
        {
            if(targetSplitText.textFields[i].label == targetTextField.label)
            {
                startIndexFound = true;
                width += targetSplitText.textFields[i].width;
                continue;
            }
            if(startIndexFound)
            {
                width += targetSplitText.textFields[i].width;
            }
        }
        return width;
    }

    public populateDecodeCommands(code:string):DecodingCommand[]
    {
        let commands:DecodingCommand[] = [];
        const strings:string[] = code.split("");
        const len = strings.length;
        let capturingAudioId:boolean = false;
        let isInstruction:boolean = false;
        let curAudioId:string = null;
        let curPosition:string = null;
        let curCode:string = null;
        let curCommand:DecodingCommand;

        for(let i=0; i<len; i++)
        {
            // Break command used to separate commands
            if(strings[i] == MarkCodes.COMMAND_BREAK)
            {
                curCommand = new DecodingCommand();
                curCommand.audioId = curAudioId;
                curCommand.position = Number(curPosition);
                curCommand.code = curCode;
                curCommand.placement = this.getSymbolPlacement(curCode);
                curCommand.isInstruction = isInstruction;
                commands.push(curCommand);
                curAudioId = null;
                curPosition = null;
                curCode = null;
                capturingAudioId = false;
                isInstruction = false;
                continue;
            }

            // Check for audio id start and stop
            if(strings[i] == MarkCodes.AUDIO_ID_START)
            {
                capturingAudioId = true;
                continue;
            }
            else if(strings[i] == MarkCodes.AUDIO_ID_STOP)
            {
                capturingAudioId = false;
                continue;
            }

            // Check for instruction start and stop
            if(strings[i] == MarkCodes.INSTRUCT_START)
            {
                isInstruction = true;
                continue;
            }
            else if(strings[i] == MarkCodes.INSTRUCT_STOP)
            {
                // Instruction capture complete
                continue;
            }

            // First iteration
            if(i == 0)
            {
                if(this.isNumber(strings[i]))
                {
                    curPosition = strings[i];
                }
                continue;
            }

            // Non audio id number that is used in the position of the command
            if(this.isNumber(strings[i]) && !capturingAudioId)
            {
                if(curPosition == null)
                {
                    curPosition = "";
                }

                curPosition += strings[i];
            }
            // Audio id number that is used in the audio id of the command
            else if(this.isNumber(strings[i]) && capturingAudioId)
            {
                if(curAudioId == null)
                {
                    curAudioId = "";
                }
                curAudioId += strings[i];
            }
            // Code character that is used in the code of the command
            else
            {
                if(curCode == null)
                {
                    curCode = "";
                }
                curCode += strings[i];
            }

            // Last iteration
            if(i == len-1)
            {
                curCommand = new DecodingCommand();
                curCommand.audioId = curAudioId;
                curCommand.position = Number(curPosition);
                curCommand.code = curCode;
                curCommand.placement = this.getSymbolPlacement(curCode);
                curCommand.isInstruction = isInstruction;
                commands.push(curCommand);
            }
        }
        this._decodingCommands = commands;
        return commands;
    }
}